module.exports = __webpack_public_path__ + "media/images/messagecards/birthday-3cf41b540c41086ca32e7752c42cbb9f.jpg";